/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const filesAPI = {
  // Le categorie dei documenti arrivano dall'API: cambiano con il catalogo dei
  // prodotti e non vanno cablate qui dentro.
  categorieDocumento: async () => {
    const { data } = await apiClient.get('/files/categorie-documento');
    return data;
  },
  // Documenti attaccati all'apparecchio di UN cliente, non al tipo di prodotto.
  listaProdotto: async (prodottoClienteId) => {
    const { data } = await apiClient.get(`/files/prodotto/${prodottoClienteId}`);
    return data;
  },
  statsProdotto: async (prodottoClienteId) => {
    const { data } = await apiClient.get(`/files/prodotto/${prodottoClienteId}/stats`);
    return data;
  },
  uploadProdotto: async (prodottoClienteId, file, categoriaDocumento, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('categoria_documento', categoriaDocumento || '');
    const { data } = await apiClient.post(`/files/prodotto/${prodottoClienteId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
    return data;
  },
  remove: async (id) => {
    const { data } = await apiClient.delete(`/files/${id}`);
    return data;
  },
};
